import fp from 'lodash/fp';
import { put, takeLatest, takeEvery, all, call } from 'redux-saga/effects';
import { cryptoProfiles } from '@factorin/rest';
import { cryptoprofiles } from '@factorin/container.macro';

import { apiCall } from 'Modules/core/api';
import { getCert } from 'Modules/business/cryptopro';
import { messagingActions } from 'Modules/core/messaging';

import { cryptoprofilesActions } from './actions';
import { notifyCryptoProError, updateCertificateList } from '../certificates/sagas';


export function* uploadCertificate(thumbprint) {
    const certRaw = yield getCert(thumbprint);
    const base64certificate = yield certRaw.exportBase64();

    yield apiCall(cryptoProfiles.add, { base64certificate });

    yield put(messagingActions.showNotification({
        content: 'cryptoprofiles.successAdd',
    }));

    const certificates = yield apiCall(cryptoProfiles.list);
    yield put(cryptoprofilesActions.load(certificates));
}

function* cryptoprofileChanged() {
    yield all(fp.map(call, cryptoprofiles.certificateChangedSagas));
}

export function* addCertificate({ $payload: { certificate } }) {
    try {
        yield uploadCertificate(certificate);
        yield updateCertificateList({ path: 'addToProfile' });
        yield cryptoprofileChanged();
    } catch (err) {
        yield notifyCryptoProError('notifications:cryptoprofiles.errorAdd', err);
    }
}

export function* getCryptoProfiles() {
    const certificates = yield apiCall(cryptoProfiles.list);
    yield put(cryptoprofilesActions.init(certificates));
}

export function* removeCryproProfile({ $payload: id }) {
    try {
        yield apiCall(cryptoProfiles.remove, { id });

        yield put(messagingActions.showNotification({
            content: 'cryptoprofiles.successRemove',
        }));

        const certificates = yield apiCall(cryptoProfiles.list);
        yield put(cryptoprofilesActions.load(certificates));
        yield updateCertificateList({ path: 'addToProfile' });
        yield cryptoprofileChanged();
    } catch (error) {
        yield put(messagingActions.showNotification({
            content: 'cryptoprofiles.errorRemove',
        }));
    }
}

export const sagas = [
    takeLatest(`${cryptoprofilesActions.registerCert}`, addCertificate),
    takeEvery(`${cryptoprofilesActions.remove}`, removeCryproProfile),
];
